/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDirtyDataReset = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2h2v2.542c.904-.801 1.763-1.366 2.584-1.757A7.932 7.932 0 0 1 12.11 2C17.665 2 22 6.948 22 12.834c0 .734-.067 1.452-.194 2.147l-1.967-.361A9.893 9.893 0 0 0 20 12.834C20 7.858 16.375 4 12.111 4c-.78 0-1.653.107-2.667.59-.618.295-1.308.738-2.073 1.41H10v2H4V2zm5.601 10.934c-1.723-1.093-4.025-.924-5.524.575L1.1 16.485l6.364 6.364 2.976-2.976c1.5-1.5 1.669-3.801.575-5.524l3.167-3.167-1.414-1.414L9.6 12.934zm-.63 2.044c.992.991.987 2.55.055 3.48l-1.562 1.563-1.06-1.06 1.414-1.415-1.414-1.414-1.414 1.414-1.061-1.06 1.562-1.563c.931-.93 2.49-.936 3.48.055zm8.582 3.128c.626-.314 1.369-1.089 1.833-2.043l1.798.874c-.605 1.245-1.623 2.4-2.737 2.957l-.894-1.788zm-.606 2.788c-.91.456-2.543.91-3.204 1.076l-.486-1.94c.673-.168 2.106-.58 2.796-.924l.894 1.788z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDirtyDataReset as DirtyDataReset };
